export default (theme) => ({
  dialogPaper: {
    width: "640px",
    maxWidth: "calc(100vw - 32px)",
  },
  headerTitle: {
    fontWeight: 500,
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    fontSize: "20px",
    color: "#ffffff",
    textAlign: "center",
    width: "100%",
    padding: "14px 16px",
  },
  dialogBody: {
    padding: theme.spacing(3),
  },
  loadingWrap: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(4, 0),
  },
  greetingText: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 500,
  },
  descriptionText: {
    marginBottom: theme.spacing(2),
  },
  formFields: {
    marginBottom: theme.spacing(2),
  },
  textField: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  fieldError: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(-1.5),
    marginBottom: theme.spacing(1.5),
  },
  dropdownOptionPrimary: {
    fontWeight: 500,
    lineHeight: 1.3,
  },
  dropdownOptionSecondary: {
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
    marginTop: theme.spacing(0.25),
  },
  menu: {
    maxHeight: 320,
  },
  notListedOption: {
    color: theme.palette.error.main,
  },
  buttonRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  cancelButtonWrap: {
    justifySelf: "start",
  },
  submitButtonWrap: {
    gridColumn: 2,
    justifySelf: "center",
  },
  cancelButton: {
    minWidth: "110px",
    fontSize: "12px",
    fontWeight: 500,
    padding: "8px 18px",
  },
  submitButton: {
    minWidth: "130px",
    fontSize: "14px",
    padding: "8px 18px",
  },
  successMessageWrap: {
    textAlign: "center",
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  successMessage: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  autoCloseHint: {
    color: "#4a5a62",
    fontSize: "13px",
  },
});
